import React from 'react'

import {OrderProcessTimePickerStep} from '../../../../shared/order-editor/components/fields/Time/TimePicker/OrderProcessTimePickerStep'
import {OrderProcessTimeSlotPickerStep} from '../../../../shared/order-editor/components/fields/Time/TimeSlotPicker/OrderProcessTimeSlotPickerStep'
import {
  useFeatureShowOutOfOperationalHoursSlotsForRmcOrderIntake,
  useFeatureSlotManagementForRmcOrderIntakeEnabled
} from '../../../../shared/order-editor/components/fields/Time/useFeatureFlag'
import {useSlotManagement} from '../../../../shared/order-editor/components/fields/Time/useSlotManagement'

/**
 * OrderIntakeTimeStep component for order intake.
 * Conditionally renders either slot-based or regular time picker
 * based on slot management feature flag.
 * This is used in the order intake context.
 */
export const OrderIntakeTimeStep: React.FC = () => {
  const isFeatureEnabled = useFeatureSlotManagementForRmcOrderIntakeEnabled()

  if (isFeatureEnabled) {
    return <OrderIntakeTimeSlotPickerStep />
  }

  return <OrderProcessTimePickerStep />
}

const OrderIntakeTimeSlotPickerStep: React.FC = () => {
  const showOutOfOperationalHoursSlots = useFeatureShowOutOfOperationalHoursSlotsForRmcOrderIntake()
  const slotManagementOptions = useSlotManagement()

  return (
    <OrderProcessTimeSlotPickerStep
      availableSlots={slotManagementOptions.availableSlots}
      autoConfirmAvailability={{
        isOutOfLeadTime: slotManagementOptions.isOutOfAutoConfirmLeadTime,
        isQuantityExceeded: slotManagementOptions.isMaxAutoConfirmQuantityExceeded ?? false,
        isUnavailable: slotManagementOptions.instantApprovalUnavailable
      }}
      isLoading={slotManagementOptions.isLoading}
      selectedSlot={{
        isAvailable: slotManagementOptions.isSelectedSlotAvailable,
        showUnavailableBanner: slotManagementOptions.showBannerWhenSlotIsUnavailable
      }}
      showOutOfOperationalHoursSlots={showOutOfOperationalHoursSlots}
    />
  )
}
